import { Controller, get } from 'react-hook-form';

import { Calendar } from 'primereact/calendar';
import { classNames } from 'primereact/utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function DateTimePicker({
  label,
  name,
  isRequired,
  disabled,
  control,
  errors,
  isFontWeightLabel,
  onCustomChange,
  defaultValue,
  readOnly,
}) {
  const { t } = useTranslation();

  return (
    <div className="field">
      {(label !== '' || isRequired) && (
        <label htmlFor={name} style={isFontWeightLabel ? { fontWeight: 900 } : {}}>
          {label}{' '}
          {isRequired && (
            <span className="text-red-500" style={{ fontWeight: 900 }}>
              *
            </span>
          )}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        defaultValue={defaultValue}
        render={({ field: { onChange, value, ref } }) => (
          <Calendar
            showIcon={!readOnly}
            showButtonBar
            value={value}
            onChange={(e) => {
              onChange(e.value);
              onCustomChange(name, value);
            }}
            ref={ref}
            dateFormat="dd/mm/yy"
            locale={t('lang') !== 'lang' ? t('lang') : 'vi'}
            className={classNames({
              'p-invalid': !!get(errors, name),
              'surface-200': disabled,
            })}
            inputStyle={{
              ...(readOnly && { opacity: 1 }),
            }}
            tooltip={t(get(errors, name)?.message)}
            tooltipOptions={{ position: 'bottom' }}
            disabled={disabled || readOnly}
            showTime
            hourFormat="24"
            stepMinute={5}
          />
        )}
      />
    </div>
  );
}

DateTimePicker.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  control: PropTypes.shape({}).isRequired,
  errors: PropTypes.shape({}).isRequired,
  isFontWeightLabel: PropTypes.bool,
  onCustomChange: PropTypes.func,
  defaultValue: PropTypes.instanceOf(Date),
  readOnly: PropTypes.bool,
};

DateTimePicker.defaultProps = {
  label: '',
  isRequired: false,
  disabled: false,
  isFontWeightLabel: false,
  onCustomChange: () => null,
  defaultValue: null,
  readOnly: false,
};
